var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v("There is a recent account registration process for this credentials, please try to "),_c('MPWhiteLink',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.goToSignIn()}}},[_vm._v("Sign In")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }